<template>
  <div class="index-container">
    <div
      class="banner"
      @mouseover="swiperMouseover"
      @mouseleave="swiperMouseleave"
    >
      <swiper
        class="swiper"
        id="swiperBanner"
        :options="swiperOptionBanner"
        ref="swiperBanner"
      >
        <swiper-slide
          v-for="(item, index) in info.banner"
          :key="index"
          style="font-size: 0"
        >
          <img :src="item.image" @click="toUrl(item.url)" />
        </swiper-slide>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
      <!-- 自定义分页器 -->
      <div class="swiper-num">
        <span class="active">{{ active }}</span
        >/
        <span class="total">{{ total }}</span>
      </div>
    </div>
    <div class="recommend-course">
      <div class="mwframe1200">
        <p class="title">技术在线</p>
        <div class="sub-title">Technology Online</div>
        <div class="recommend-box flex_align">
          <div
            class="recommend-item flex_align"
            v-for="(item, index) in info.course_category"
            :key="index"
          >
            <div class="recommend-left">
              <img :src="item.image" />
            </div>
            <div class="recommend-rigth">
              <el-carousel
                type="card"
                height="140px"
                arrow="never"
                indicator-position="none"
                :interval="0"
              >
                <el-carousel-item
                  v-for="(item2, index2) in item.course"
                  :key="index2"
                >
                  <div class="course">
                    <img class="tuijianing" :src="item2.image" />
                    <div class="desc flex_align_between">
                      <span>{{ item2.title }}</span>
                      <i class="el-icon-right" @click="toCourse(item2.id)"></i>
                    </div>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
        </div>
        <p class="more-course" @click="toMoreCourse">更多</p>
      </div>
    </div>
    <div class="company-desc" v-if="info.company">
      <div class="title">公司简介</div>
      <div style="position: relative; width: 1000px; margin: 0 auto">
        <div
          class="desc"
          ref="company_desc"
          :style="{ maxHeight: !is_open ? '92px' : '1000px' }"
          v-html="info.company.index_intro"
        ></div>
        <div class="open" v-if="is_show_open" @click="is_open = !is_open">
          {{ is_open == false ? "展开" : "收起" }}
        </div>
      </div>

      <div class="company-images flex_align_between">
        <div
          class="desc-left"
          @mouseover="swiperMouseover1"
          @mouseleave="swiperMouseleave1"
        >
          <swiper
            class="swiper gallery-thumbs"
            :options="swiperOptionThumbs"
            ref="swiperThumbs"
          >
            <swiper-slide v-for="(item, index) in info.idea" :key="index">
              <img :src="item.image" />
            </swiper-slide>

            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
        <div
          class="desc-right"
          @mouseover="swiperMouseover1"
          @mouseleave="swiperMouseleave1"
        >
          <swiper
            :options="swiperOptionTop"
            ref="swiperTop"
            style="width: 100%"
          >
            <swiper-slide v-for="(item, index) in info.idea" :key="index">
              <div v-html="item.content"></div>
            </swiper-slide>
          </swiper>
          <router-link :to="{ path: '/companyInfo' }"
            ><p class="more">READ MORE <i class="el-icon-right"></i></p
          ></router-link>
        </div>
      </div>
    </div>
    <div class="production" v-if="info.project">
      <div class="title">高薪项目</div>
      <div class="production-box flex_align_between">
        <div class="item" v-for="(item, index) in info.project" :key="index">
          <p class="name">{{ item.title }}</p>
          <div class="desc">
            {{ item.index_intro }}
          </div>

          <router-link :to="{ path: '/projectDetails/' + item.id }"
            ><div class="btn">查看详情</div></router-link
          >
        </div>
      </div>
    </div>
    <div class="student_style" v-if="info.elegant">
      <p class="title">客户案例</p>
      <div class="sub-title">Customer case</div>
      <div class="student_imgs mwframe1200">
        <div
          class="img1"
          @mouseover="swiperMouseover2('img1')"
          @mouseleave="swiperMouseleave2('img1')"
        >
          <swiper
            :options="swiperOptionStudentStyle"
            ref="img1"
            style="width: 100%"
          >
            <swiper-slide
              v-for="(item, index) in info.elegant.left"
              :key="index"
            >
              <img :src="item.image" />
              <div class="mask" v-if="item.type == 2">
                <div class="player" @click="handlePlay(item.video)">
                  <p><i class="el-icon-video-play"></i> 观看视频</p>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
        <div
          class="img2"
          @mouseover="swiperMouseover2('img2')"
          @mouseleave="swiperMouseleave2('img2')"
        >
          <swiper
            :options="swiperOptionStudentStyle"
            ref="img2"
            style="width: 100%"
          >
            <swiper-slide
              v-for="(item, index) in info.elegant.center"
              :key="index"
            >
              <img :src="item.image" />
              <div class="mask" v-if="item.type == 2">
                <div class="player" @click="handlePlay(item.video)">
                  <p><i class="el-icon-video-play"></i> 观看视频</p>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
        <div class="imgs">
          <div
            class="img3"
            @mouseover="swiperMouseover2('img3')"
            @mouseleave="swiperMouseleave2('img3')"
          >
            <swiper
              :options="swiperOptionStudentStyle"
              ref="img3"
              style="width: 100%"
            >
              <swiper-slide
                v-for="(item, index) in info.elegant.right_top"
                :key="index"
              >
                <img :src="item.image" />
                <div class="mask" v-if="item.type == 2">
                  <div class="player" @click="handlePlay(item.video)">
                    <p><i class="el-icon-video-play"></i> 观看视频</p>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
          <div class="img4" v-if="info.elegant.right_bottom">
            <img :src="info.elegant.right_bottom.image" />
            <div class="mask" v-if="info.elegant.right_bottom.type == 2">
              <div
                class="player"
                @click="handlePlay(info.elegant.right_bottom.video)"
              >
                <p><i class="el-icon-video-play"></i> 观看视频</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="partner" v-if="info.partner">
      <div class="title">合作伙伴</div>
      <div
        class="partner-box"
        @mouseover="swiperMouseover3"
        @mouseleave="swiperMouseleave3"
      >
        <swiper
          class="swiper"
          :options="swiperOptionPartner"
          ref="swiperPartner"
        >
          <swiper-slide v-for="(item, index) in info.partner" :key="index">
            <div class="symmetry partner-swiper">
              <div class="item-box">
                <div class="item" v-for="item2 in item" :key="item2">
                  <a :href="item2.url" target="_blank">
                    <img :src="item2.image" alt=""
                  /></a>
                </div>
              </div>
            </div>
          </swiper-slide>
          <!-- <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div> -->
        </swiper>
      </div>
    </div>
    <div class="mask_window" v-if="showVideo">
      <div class="video-box">
        <div class="x el-icon-close" @click="showVideo = false"></div>
        <video-player
          class="video-player vjs-custom-skin"
          style="margin-bottom: 20px"
          ref="videoPlayer"
          :playsinline="true"
          :options="playerOptions"
          @ready="playerReadied"
        ></video-player>
      </div>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      banner: require("@/assets/img/index_banner.png"),
      tuijia_1: require("@/assets/img/index_tuijian_1.png"),
      tuijia_2: require("@/assets/img/index_tuijian_2.png"),
      tuijia_3: require("@/assets/img/index_tuijian_3.png"),
      tuijia_4: require("@/assets/img/index_tuijian_4.png"),
      tuijia_5: require("@/assets/img/index_tuijian_5.png"),
      company_img: require("@/assets/img/company_img.png"),
      img1: require("@/assets/img/img1.jpg"),
      // 图片父容器高度
      bannerHeight: 640,
      // 浏览器宽度
      screenWidth: 0,
      info: {},

      swiperOptionTop: {
        // loop: true,
        // loopedSlides: 5, // looped slides should be the same
        spaceBetween: 20,
      },
      swiperOptionThumbs: {
        // loop: true,
        // loopedSlides: 5, // looped slides should be the same
        spaceBetween: 0,

        autoplay: true,
        // centeredSlides: true,
        // slidesPerView: "auto",
        // touchRatio: 0.2,
        // slideToClickedSlide: true,
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      swiperOptionStudentStyle: {
        spaceBetween: 0,
        autoplay: true,
      },
      swiperOptionBanner: {},
      swiperOptionPartner: {
        slidesPerView: "auto",
        autoplay: {
          delay: 0,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        loop: true,
        speed: 3000, //匀速时间

        // navigation: {
        //   nextEl: ".swiper-button-next",
        //   prevEl: ".swiper-button-prev",
        // },
      },
      active: "",
      total: "",

      showVideo: false,
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: false, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            // src: '../../static/video/test.mp4', // 路径
            src: "",
            type: "video/mp4", // 类型
          },
        ],
        // poster: require("@/assets/img/thumb.jpg"), // 你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, // 全屏按钮
        },
      },
      max_height: 92,
      is_show_open: false,
      is_open: true,
    };
  },
  mounted() {
    // 首次加载时,需要调用一次
    this.screenWidth = window.innerWidth;
    this.setSize();
    // 窗口大小发生改变时,调用一次
    window.onresize = () => {
      this.screenWidth = window.innerWidth;
      this.setSize();
    };
  },
  created() {
    let _this = this;
    _this.swiperOptionBanner = {
      autoplay: true,
      loop: true,
      loopedSlides: 5, // looped slides should be the same
      slidesPerView: "auto",
      slideToClickedSlide: true,
      pagination: {
        el: ".swiper-pagination",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      on: {
        init: function () {
          _this.active = this.realIndex + 1;
        },
        slideChangeTransitionEnd: function () {
          _this.active = this.realIndex + 1;
        },
      },
    };
    this.getData();
  },

  methods: {
    swiperMouseover: function () {
      this.$refs.swiperBanner.$swiper.autoplay.stop();
    },
    swiperMouseleave: function () {
      this.$refs.swiperBanner.$swiper.autoplay.start();
    },

    swiperMouseover1: function () {
      this.$refs.swiperThumbs.$swiper.autoplay.stop();
    },
    swiperMouseleave1: function () {
      this.$refs.swiperThumbs.$swiper.autoplay.start();
    },
    swiperMouseover2: function (ref) {
      this.$refs[ref].$swiper.autoplay.stop();
    },
    swiperMouseleave2: function (ref) {
      this.$refs[ref].$swiper.autoplay.start();
    },
    swiperMouseover3: function () {
      console.log(this.$refs.swiperPartner.$swiper);
      this.$refs.swiperPartner.$swiper.autoplay.stop();
    },
    swiperMouseleave3: function () {
      this.$refs.swiperPartner.$swiper.autoplay.start();
    },
    setSize: function () {
      // 通过浏览器宽度(图片宽度)计算高度
      this.bannerHeight =
        (640 / 1920) * this.screenWidth >= 326
          ? (640 / 1920) * this.screenWidth
          : 326;
    },
    getData() {
      this.$myAjax(
        "student/index/index",
        "get",
        {},
        (data) => {
          let partner = [],
            partner_item = [];
          data.partner.map((item) => {
            partner_item.push(item);
            if (partner_item.length === 2) {
              partner.push(partner_item);
              partner_item = [];
            }
          });
          data.partner = partner;
          this.info = data;

          this.total = this.info.banner.length;
          this.$nextTick(() => {
            const swiperTop = this.$refs.swiperTop.$swiper;
            const swiperThumbs = this.$refs.swiperThumbs.$swiper;
            swiperTop.controller.control = swiperThumbs;
            swiperThumbs.controller.control = swiperTop;
            let line_div = document.createElement("div");
            line_div.className = "line";
            let s = document.getElementById("swiperBanner");
            s.appendChild(line_div);
            //company_desc
            let height = this.$refs.company_desc.offsetHeight;
            console.log(height);
            if (height > this.max_height) {
              this.is_show_open = true;
              this.is_open = false;
            }
          });
        },
        () => {}
      );
    },
    onSlideChangeEnd() {
      console.log(2);
    },
    playerReadied(v) {
      console.log(v);
    },
    handlePlay(v) {
      this.playerOptions.sources[0].src = v;
      this.showVideo = true;
      console.log(this.playerOptions);
    },
    toCourse(id) {
      this.$router.push({ path: "/courseDetails/" + id });
    },
    toUrl(u) {
      console.log(u);
      if (u != "") {
        window.location.href = u;
      }
    },
    toMoreCourse() {
      this.$router.push({ name: "courseList" });
    },
  },
};
</script>
<style lang="scss">
.video-js {
  background: none;
}
video {
  border-radius: 10px;
}
img {
  width: 100%;
}

.el-carousel__indicator.is-active button {
  background-color: #f08519;
}

.recommend-course {
  .el-carousel__mask {
    background-color: #071543;
    opacity: 0.7;
    z-index: 1;
  }
}
.company-desc {
  .desc {
    p {
      font-size: 12px;
      line-height: 23px !important;
    }
  }
}
.company-desc {
  .company-images {
    .desc-left {
      .swiper-button-prev,
      .swiper-button-next {
        color: #fff;
        width: 50px;
        height: 30px;
        background: #ffffff82;
        backdrop-filter: blur(30px);
      }
      .swiper-button-prev {
        left: 10px;
        right: auto;
        bottom: 10px;
        top: unset;
        &::after {
          font-size: 15px;
        }
      }
      .swiper-button-next {
        left: 65px;
        top: unset;
        bottom: 10px;
        &::after {
          font-size: 15px;
        }
      }
    }
    .desc-right {
      p {
        color: #222222;
        margin-bottom: 10px;
      }
    }
  }
}
.partner {
  .swiper-button-prev,
  .swiper-button-next {
    width: 40px;
    height: 40px;
    background: #000000;
    border-radius: 50%;
    opacity: 0.5;
    color: #fff;
  }
  .swiper-button-prev:after,
  .swiper-button-next:after {
    font-size: 18px;
  }
  .swiper-button-next,
  .swiper-container-rtl .swiper-button-prev {
    right: 0;
  }
  .swiper-button-prev,
  .swiper-container-rtl .swiper-button-next {
    left: 0;
  }
}
.banner {
  position: relative;
  .swiper-button-prev,
  .swiper-button-next {
    color: #fff;
    width: 30px;
    height: 25px;
    background: rgb(0 0 0 / 50%);
  }
  .swiper-button-prev {
    right: calc(20% + 30px);
    left: auto;
    bottom: 10px;
    top: unset;
    &::after {
      font-size: 12px;
    }
    border-radius: 15px 0 0 15px;
  }
  .swiper-button-next {
    right: 20%;
    top: unset;
    bottom: 10px;
    &::after {
      font-size: 12px;
    }
    border-radius: 0 15px 15px 0;
  }
  .swiper-pagination-bullet-active {
    background: #f08519ff;
  }
  .line {
    &::after {
      content: "";
      background: #ffffff66;
      height: 1px;
      left: 26%;
      right: 26%;
      bottom: 20px;
      position: absolute;
      z-index: 1;
    }
    width: 100%;
  }
}
.banner .swiper-pagination-bullets {
  bottom: 15px;
  width: auto;
  left: 50%;
  transform: translateX(-50%);
  z-index: 5;
}

.banner .swiper-pagination-bullet {
  width: 40px;
  height: 5px;
  border-radius: 0;
}
.swiper-num {
  position: absolute;
  width: 60px;
  height: 25px;
  line-height: 25px;
  left: 20%;
  bottom: 10px;
  z-index: 2;
  background: rgb(0 0 0 / 50%);
  border-radius: 15px;
  color: #fff;
  font-size: 12px;
  text-align: center;
}
.swiper-num .active {
  display: inline-block;
}
.swiper-num .total {
  display: inline-block;
}

.blue-slide {
  background: #4390ee;
  color: #fff;
}
.red-slide {
  background: #ca4040;
  color: #fff;
}
.orange-slide {
  background: #ff8604;
  color: #fff;
}
.gray-slide {
  background: gray;
  color: #fff;
}
.mask_window {
  video {
    // width: 100% !important;
    // object-fit: fill; //消除留白
  }
}
.partner {
  .swiper-wrapper {
    -webkit-transition-timing-function: linear; /*之前是ease-out*/
    -moz-transition-timing-function: linear;
    -ms-transition-timing-function: linear;
    -o-transition-timing-function: linear;
    transition-timing-function: linear;
    margin: 0 auto;
  }
  .swiper-slide {
    width: auto;
  }
}
</style>

<style lang="scss" scoped>
.index-container {
  .sub-title {
    height: 29px;
    font-size: 24px;
    font-family: DIN;
    font-weight: 500;
    line-height: 29px;
    color: rgb(66 101 214 / 15%);
    text-align: center;
    margin-top: -40px;
    z-index: 0;
  }
  .recommend-course {
    background: url("~@/assets/img/index_bg1.png") no-repeat;
    background-attachment: fixed;
    background-size: auto 100%;
    padding: 10px 0;
    position: relative;
    .recommend-box {
      flex-wrap: wrap;
      .recommend-left {
        img {
          // width: 1.8rem;
          width: 180px;
        }
        margin-right: 30px;
      }
      .recommend-rigth {
        flex-grow: 1;

        .course {
          //   width: 2.4rem;
          position: relative;
        }

        .tuijianing.img {
          width: 100%;
        }
        .desc {
          width: 100%;
          background: #fff;
          bottom: -25px;
          height: 30px;
          position: absolute;
          padding: 0 10px;
          span {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }
    .title {
      text-align: center;
      color: #fff;
      font-size: 20px;
      padding-top: 10px;
      padding-bottom: 20px;
      //   &::after {
      //     background: url("~@/assets/img/recommend_ courses.png");
      //     content: "";
      //     height: 29px;
      //     position: absolute;
      //     top: 25px;
      //     width: 100%;
      //     left: 0;
      //     right: 0;
      //     background-repeat: no-repeat;
      //     background-position-x: center;
      //     background-size: auto 100%;
      //   }
    }

    .recommend-item {
      width: 50%;
      padding-top: 40px;
      &:nth-child(2n + 1) {
        padding-right: 15px;
      }
      &:nth-child(2n) {
        padding-left: 15px;
      }
    }
    .more-course {
      width: 150px;
      height: 48px;
      line-height: 48px;
      background: linear-gradient(90deg, #007deb 0%, #0038eb 100%);
      opacity: 1;
      border-radius: 24px;
      text-align: center;
      color: #fff;
      margin: 0 auto;
      bottom: 10px;
      margin-top: 50px;
      cursor: pointer;
    }
  }
  .company-desc {
    background: url("~@/assets/img/index_bg2.png") center;
    // background-attachment: fixed;
    background-size: auto 100%;
    background-repeat: no-repeat;
    // min-height: calc(100vw * 0.3885);
    padding-top: 40px;
    padding-bottom: 70px;
    .title {
      height: 33px;
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 800;
      line-height: 33px;
      color: #222222;
      opacity: 1;
      text-align: center;
      position: relative;
      margin-bottom: 50px;
      &::after {
        background: url("~@/assets/img/company_introduction.png");
        content: "";
        height: 29px;
        position: absolute;
        top: 10px;
        width: 100%;
        left: 0;
        right: 0;
        background-repeat: no-repeat;
        background-position-x: center;
      }
    }
    .desc {
      width: 1000px;
      //   height: 65px;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      line-height: 17px;
      margin: 0 auto;
      overflow: hidden;
      margin-bottom: 30px;
      p {
        font-size: 12px;
      }
    }
    .open {
      position: absolute;
      bottom: 0;
      right: 0;
      background: #fff;
      color: #2f4fedff;
      font-size: 12px;
      width: 40px;
      text-align: right;
      cursor: pointer;
    }
    .company-images {
      margin: 0 auto;
      justify-content: center;
      padding-bottom: 23px;
      .desc-left {
        width: 800px;
      }
      .desc-right {
        width: 450px;
        height: 340px;
        background: #d0dbebd1;
        // filter: blur(0.5px);

        display: flex;
        flex-direction: column;
        margin-left: -50px;
        z-index: 2;
        padding: 20px;
        position: relative;
        overflow: hidden;
        p {
          color: #222222;
          margin-bottom: 10px;
        }
        .more {
          height: 12px;
          font-size: 9px;
          font-family: PingFang SC;
          font-weight: 500;
          line-height: 17px;
          color: #768aa8;
          text-align: right;
          position: absolute;
          bottom: 10px;
          right: 10px;
        }
        .desc-right_item {
          height: 50%;
          padding: 20px;
          p {
            &.text1 {
              height: 18px;
              font-size: 13px;
              font-family: PingFang SC;
              font-weight: 800;
              line-height: 17px;
              color: #222222;
              margin-bottom: 10px;
            }
            &.text2 {
              height: 31px;
              font-size: 10px;
              font-family: PingFang SC;
              font-weight: 500;
              line-height: 17px;
              color: #222222;
              opacity: 1;
            }
            &.more {
              height: 12px;
              font-size: 9px;
              font-family: PingFang SC;
              font-weight: 500;
              line-height: 17px;
              color: #768aa8;
              text-align: right;
              margin-top: 10px;
              margin-right: 10px;
            }
          }
        }
      }
    }
  }
  .production {
    background: url("~@/assets/img/index_bg3.png");
    min-height: calc(100vw * 0.3544);
    margin-bottom: 20px;
    background-size: 100%;
    padding-top: 0.8rem;
    background-repeat: no-repeat;
    margin-top: -70px;
    .title {
      height: 23px;
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 800;
      line-height: 23px;
      color: #ffffff;
      opacity: 1;
      text-align: center;
      position: relative;
      margin-bottom: 0.5rem;
      &::after {
        background: url("~@/assets/img/company_introduction.png");
        content: "";
        height: 29px;
        position: absolute;
        top: 10px;
        width: 100%;
        left: 0;
        right: 0;
        background-repeat: no-repeat;
        background-position-x: center;
      }
    }
    .production-box {
      width: 12rem;
      margin: 0 auto;
      .item {
        width: 2.8rem;
        height: 3.4rem;
        background: #48aafd;
        border-radius: 0.2rem;
        box-shadow: 0px 7px 11px rgba(38, 62, 139, 0.3);
        backdrop-filter: blur(2px);
        transition: all 0.5s;
        &:hover {
          background: #ffffff;
          .name {
            color: #222222;
          }
          .desc {
            color: #929ba8;
          }
          .btn {
            cursor: pointer;
            background: linear-gradient(
              90deg,
              #4ad3ff 0%,
              #3ba3f5 54%,
              #3692f2 73%,
              #2f7bed 100%
            );
          }
        }
        &:nth-child(1) {
          .name::after {
            background: url("~@/assets/img/01.png");
            background-repeat: no-repeat;
            background-position-x: center;
            background-size: 57px 69px;
          }
        }
        &:nth-child(2) {
          .name::after {
            background: url("~@/assets/img/02.png");
            background-repeat: no-repeat;
            background-position-x: center;
            background-size: 57px 69px;
          }
        }
        &:nth-child(3) {
          .name::after {
            background: url("~@/assets/img/03.png");
            background-repeat: no-repeat;
            background-position-x: center;
            background-size: 57px 69px;
          }
        }
        &:nth-child(4) {
          .name::after {
            background: url("~@/assets/img/04.png");
            background-repeat: no-repeat;
            background-position-x: center;
            background-size: 57px 69px;
          }
        }
        .name {
          font-size: 13px;
          font-family: PingFang SC;
          font-weight: bold;
          line-height: 20px;
          color: #ffffff;
          text-align: center;
          padding-top: 21px;
          position: relative;
          //   &:nth-child(1)::after {
          //     background: url("~@/assets/img/01.png");
          //   }
          //   &:nth-child(2)::after {
          //     background: url("~@/assets/img/02.png");
          //   }
          //   &:nth-child(3)::after {
          //     background: url("~@/assets/img/03.png");
          //   }
          //   &:nth-child(4)::after {
          //     background: url("~@/assets/img/04.png");
          //   }
          &::after {
            content: "";
            height: 69px;
            position: absolute;
            top: 0;
            width: 100%;
            left: 0;
            right: 0;
            z-index: 9;
          }
        }
        .desc {
          width: 2.1rem;
          height: 1.8rem;
          font-size: 0.14rem;
          font-family: PingFang SC;
          font-weight: 500;
          line-height: 0.24rem;
          color: #fff;
          margin: 15px auto;
          overflow: auto;
          box-sizing: border-box;
          &::-webkit-scrollbar {
            /*滚动条整体样式*/
            width: 5px;
            /*高宽分别对应横竖滚动条的尺寸*/
            height: 1px;
            margin: 2px 2px 2px;
            border-radius: 10px;
          }

          &::-webkit-scrollbar-thumb {
            /*滚动条里面小方块*/
            border-radius: 10px;
            box-shadow: inset 0 0 2px #b3c4de;
            background: #b3c4de;
          }

          &::-webkit-scrollbar-track {
            border-radius: 10px;
            /*滚动条里面轨道*/
            box-shadow: inset 0 0 2px #e4e8ee;
            // border-radius: 10px;
            background: #e4e8ee;
          }
        }
        .btn {
          width: 1rem;
          height: 0.4rem;
          line-height: 0.4rem;

          border: 1px solid #ffffff;
          background: none;
          border-radius: 0.2rem;
          color: #fff;
          margin: 0 auto;
          font-size: 0.14rem;
          text-align: center;
        }
      }
    }
  }
  .student_style {
    background: url("~@/assets/img/index_bg4_1.png") center;
    // min-height: calc(100vw * 0.335);
    margin-bottom: 20px;
    background-size: auto 100%;
    padding-top: 24px;
    background-repeat: no-repeat;
    padding-bottom: 80px;
    .title {
      height: 33px;
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 800;
      line-height: 33px;
      opacity: 1;
      text-align: center;
      position: relative;
      margin-bottom: 20px;
    //   &::after {
    //     background: url("~@/assets/img/student_style.png");
    //     content: "";
    //     height: 29px;
    //     position: absolute;
    //     top: 10px;
    //     width: 100%;
    //     left: 0;
    //     right: 0;
    //     background-repeat: no-repeat;
    //     background-position-x: center;
    //     background-size: auto 100%;
    //   }
    }
    .student_imgs {
      display: flex;
      justify-content: flex-end;
      background: url("~@/assets/img/index_bg4_2.png") no-repeat;
      background-size: auto 100%;
      margin-top: 40px;
      .img1 {
        width: 330px;
        height: 250px;
        overflow: hidden;
        position: relative;
        img {
          height: 100%;
          width: 100%;
        }
      }
      .img2 {
        width: 330px;
        height: 450px;
        margin: 0 15px;
        overflow: hidden;
        position: relative;
        img {
          height: 100%;
          width: auto;
        }
      }
      .img3 {
        width: 330px;
        height: 218px;
        margin-bottom: 15px;
        overflow: hidden;
        position: relative;
        img {
          height: 100%;
          width: 100%;
        }
      }
      .img4 {
        width: 330px;
        height: 218px;
        overflow: hidden;
        position: relative;
        img {
          height: 100%;
          width: 100%;
        }
      }
      .mask {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgb(0 0 0 / 30%);
        .player {
          width: 150px;
          height: 48px;
          line-height: 48px;
          border-radius: 24px;
          backdrop-filter: blur(10px);
          background: rgb(0 0 0 / 10%);
          color: #fff;
          text-align: center;
          font-size: 14px;
          cursor: pointer;
          p {
            font-size: 14px;
          }
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          margin: 0 auto;
        }
      }
    }
  }
  .partner {
    margin-bottom: 20px;
    .title {
      height: 23px;
      font-size: 0.24rem;
      font-family: PingFang SC;
      font-weight: 800;
      line-height: 23px;
      color: #222222;
      text-align: center;
      position: relative;
      margin-bottom: 0.5rem;
      &::after {
        background: url("~@/assets/img/cooperative_partner.png");
        content: "";
        height: 29px;
        position: absolute;
        top: 10px;
        width: 100%;
        left: 0;
        right: 0;
        background-repeat: no-repeat;
        background-position-x: center;
        background-size: auto 100%;
      }
    }
    .partner-box {
      //   border-top: 1px solid #f2f2f2ff;
      width: 1200px;
      margin: 0 auto;
      .partner-swiper {
        flex-wrap: wrap;
        // margin: 0 50px;
        border-top: 1px solid #f2f2f2ff;
      }
      .item-box {
        width: 200px;
        flex-shrink: 0;
        &:nth-child(6n) {
          border-right: 1px solid #f2f2f2ff;
        }
      }
      .item {
        width: 200px;
        padding: 10px;
        border-left: 1px solid #f2f2f2ff;
        border-bottom: 1px solid #f2f2f2ff;
        text-align: center;

        img {
          width: 100px;
          height: 100px;
        }
      }

      flex-wrap: wrap;
    }
  }
  .mask_window {
    width: 100vw;
    height: 100vh;
    position: fixed;
    background: rgba(0, 0, 0, 0.2);
    left: 0;
    top: 0;
    z-index: 2000;
    .x {
      //   position: absolute;
      right: -100%;
      position: relative;
      top: 15px;
      font-size: 30px;
      color: #111;
      cursor: pointer;
    }
    .video-box {
      width: 800px;
      margin: 0 auto;
      top: 50%;
      position: relative;
      transform: translateY(-50%);
    }
  }
}
</style>
